import { Question } from "@diacare/common/models/question";
import { EditPage, EditPageHeader, Field, Resource, SaveButton } from "@litbase/admin";
import { Card, FormCardTitle, HookStringSelectField, spacing } from "@litbase/alexandria";
import { useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { questionConfig } from "../models/question";

export function QuestionEditPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  return (
    <>
      <Resource config={questionConfig}>
        <Container>
          <EditPage
            // @ts-expect-error
            hideSaveButton
            successMessage={{ title: "Siker!", text: "Kérdés sikeresen mentve." }}
            transformValuesBeforeFirstRender={(values: unknown) => {
              if (params.get("lang") === "en" && id === "new") {
                return { ...(values as Record<string, unknown>), lang: "en" };
              } else {
                return values as Record<string, unknown>;
              }
            }}
            transformValuesBeforeSubmit={(values) => ({
              ...(values as Question),
              createdAt: (values as Question).createdAt || new Date(),
            })}
          >
            <EditPageHeader<Question>>
              {(item) => <h1>{item ? "Edit a question" : "Add a new question"}</h1>}
            </EditPageHeader>
            <Field property="createdAt" hidden />
            <Row>
              <Col>
                <FormCardTitle>
                  <Subtitle>Edit a question</Subtitle>
                </FormCardTitle>
                <HookStringSelectField
                  label="Language"
                  name="lang"
                  options={["hu", "en"]}
                  // @ts-expect-error
                  getOptionLabel={(option: { value: string; label: string }) =>
                    option.value === "en" ? "English" : "Hungarian"
                  }
                />
                <Field property="title" />
                <Field property="description" />
                <Field property="images" />
                <Field property="userId" />
              </Col>
              <Col>
                <FormCardTitle>
                  <Subtitle>Edit answer</Subtitle>
                </FormCardTitle>
                <Field property="answer" />
                <Field property="answerImages" />
              </Col>
            </Row>
            <Row>
              <StyledSaveButton />
            </Row>
          </EditPage>
        </Container>
      </Resource>
    </>
  );
}

const StyledSaveButton = styled(SaveButton)`
  margin-left: auto;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Col = styled(Card)`
  display: flex;
  flex-direction: column;
  max-width: 550px;
  width: 100%;
  & + & {
    margin-left: ${spacing._8};
    margin-right: auto;
  }
  &:first-child {
    margin-left: auto;
  }
  button {
    width: fit-content;
  }
  textarea {
    border: 1px solid ${({ theme }) => theme.gray300};
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
`;

const Subtitle = styled.span``;
